// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gf-list-grid-controller .gf-list-grid-controller__group>button{background-color:var(--light);border:1px solid var(--border-color)}.gf-list-grid-controller .gf-list-grid-controller__group>button:focus{box-shadow:none}.gf-list-grid-controller .gf-list-grid-controller__group>button.active{background-color:var(--border-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
